import { useFlagWithContext } from "@acto/web-common/feature-flags";

export function useRecapEditingEnabled(): boolean {
  return useFlagWithContext("field-sales-2-edit-recap", false);
}
